import { Col } from '@policygenius/mortar';
import React, { useContext } from 'react';

import SecurityNote from 'components/SecurityNote';
import ScreenSizeContext from 'contexts/ScreenSize';
import { SubmitButton } from 'forms/Inputs';

import styles from './form-wrapper.module.scss';
import { FormWrapperProps } from './types';

const FormWrapper: React.FC<FormWrapperProps> = ({
  id,
  name,
  children,
  handleSubmit,
  invalid,
  push,
  span,
  submitting,
  ctaText,
}) => {
  const { isMobile } = useContext(ScreenSizeContext);

  return (
    <Col push={push ?? { medium: 2, large: 3 }} span={span ?? { small: 4, medium: 8, large: 6 }}>
      <form id={id} name={name ?? id} className={styles.wrapper} noValidate onSubmit={handleSubmit}>
        {children}
        <SubmitButton
          className={styles.button}
          invalid={invalid}
          submitting={submitting}
          fullWidth={!!isMobile}
          ctaText={ctaText}
        />
        <SecurityNote />
      </form>
    </Col>
  );
};

export default FormWrapper;
